<template>
  <el-dropdown v-if="user" @command="handleCommand">
    <span class="el-dropdown-link">
      <app-svg-icon icon-class="user"></app-svg-icon>
      <span class="el-dropdown-link__name">{{ user.username }}</span>
      <app-svg-icon icon-class="arrow-down"></app-svg-icon>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="Setting">个人账户</el-dropdown-item>
      <!-- <el-dropdown-item command="Setting">企业信息</el-dropdown-item> -->
      <el-dropdown-item command="Logout">退出登录</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'AppSetting',
  computed: {
    user () {
      return this.$store.state.account.user
    }
  },

  methods: {
    handleCommand (command) {
      if (command === 'Logout') {
        this.$store.dispatch('logout').then(() => {
          this.$router.push({ name: 'Login' })
          this.$store.commit('LOGOUT')
          window.location.reload()
        }).catch((error) => {
          console.log('[DEBUG] error', error)
        })
      } else {
        this.$router.push({ name: command })
      }
    }
  }
}
</script>

<style lang="scss">
.el-dropdown-link {
  color: #fff;
  cursor: pointer;

  &__name {
    margin-left: 10px;
    vertical-align: middle;
  }
}
</style>
